<template>
  <div class="battery-mgmt">
    <div class="main-title">
      <p v-if="view == 'list'" @click="cancelHandle">{{ $t('lang.Battery Management') }}</p>
      <p v-if="view == 'rebind'" @click="cancelHandle">{{ $t('lang.Battery Management') }}</p>
      <p v-if="view == 'rebind'">>{{ $t('lang.Edit') }}</p>
      <p v-if="view == 'add'" @click="cancelHandle">{{ $t('lang.Battery Management') }}</p>
      <p v-if="view == 'add'">>{{ $t('lang.new') }}</p>
      <p v-if="view == 'detail'" @click="cancelHandle">{{ $t('lang.Battery Management') }}</p>
      <p v-if="view == 'detail'">>{{ $t('lang.Look Details') }}</p>
    </div>
    <div class="main-body" v-if="view == 'list'">
      <div class="list">
        <span>{{ $t('lang.Equipment Number') }}：</span>
        <el-input class="list-input fixed-width-300" size="mini" v-model="searchCondition"
          :placeholder="$t('Please enter device number')"></el-input>
        <span class="ml10 mt10">{{ $t('lang.Attribution Type') }}：</span>
        <el-select class="fixed-width-100" size="mini" v-model="belongType">
          <el-option v-for="(item, key) in belongTargetList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <span class="ml10 mt10">{{ $t('lang.Attribution Object') }}：</span>
        <el-input class="list-input fixed-width-455" style="width: 280px;" size="mini" @change="targetNumberChange"
          v-model="targetNumber"
          :placeholder="belongType === '1' ? $t('lang.Please enter your mobile phone number') : $t('lang.Please enter the name of the switchboard')"></el-input>
        <span class="ml10 mt10" v-if="belongType === '1'">{{ $t('lang.Attribution Subobject') }}：</span>
        <el-input class="list-input fixed-width-125" v-if="belongType === '1'" size="mini" v-model="belongSubNo"
          :placeholder="$t('lang.Please enter the voucher number')"></el-input>
        <span class="ml10 mt10" v-if="belongType === '2'">{{ $t('lang.Port Number') }}：</span>
        <el-select v-if="belongType === '2'" class="fixed-width-100" :disabled="!targetNumber" size="mini"
          v-model="belongTargetSeq">
          <el-option v-for="(item, index) in belongTargetSeqList" :key="index" :label="item" :value="index">
          </el-option>
        </el-select>
        <!-- <span class="ml10 mt10">版本：</span>
        <el-select
          class="fixed-width-100"
          size="mini"
          v-model="version">
          <el-option
            v-for="(item,key) in versionList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select> -->
        <div class="blue-btn ml10 mt10" @click="onQueryBtnClick">{{ $t('lang.Inquire') }}</div>
        <div class="normal-btn ml10 mt10" @click="confirmDownloadBtnClick">{{ $t('lang.Export') }}</div>
        <!-- <div class="blue-btn ml10" @click="onAddBtnClick">新增</div> -->
      </div>
      <!-- <div class="list">
        <span>电池厂商：</span>
        <el-select
          class="fixed-width-100"
          size="mini"
          v-model="manufacturer">
          <el-option
            v-for="(item,key) in manufacturerList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <span class="ml10 mt10">电池状态：</span>
        <el-select
          class="fixed-width-100"
          size="mini"
          v-model="status">
          <el-option
            v-for="(item,key) in statusList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <span class="ml10 mt10">所属组织：</span>
        <el-cascader
          class="fixed-width-200"
          :options="unitList"
          :props="{ checkStrictly: true, value:'unitNo',label:'name',children:'subUnit' }" v-model="unitNo"
          clearable></el-cascader>
        <div class="blue-btn fixed-width-100 ml10" @click="onMileageBtnClick" v-if="domainType!=2">查看电池里程</div>
        <div class="blue-btn fixed-width-100 ml10" @click="onViewTrackBtnClick">查看电池轨迹</div>
        <div class="normal-btn ml10" @click="onImportBtnClick">导入</div>
        <div class="normal-btn ml10" @click="confirmDownloadBtnClick">导出</div>
      </div> -->
      <el-table :data="dataList" style="width: 100%;margin: 20px 0;" class="table-custom">
        <!-- :tree-props="{ children: 'subMenuList', hasChildren: 'true' }" -->
        <el-table-column prop="deviceNo" :label="$t('lang.Equipment Number') + ' ' + $t('lang.Communication Board Number')"
          width="400">
          <template slot-scope="{row}">
            <!-- <br/>壳体编号：{{ item.shellNo }} -->
            {{ row.deviceNo }}<br />{{ $t('lang.Communication board number') }}：{{ row.communicationBoardNo }}
          </template>
        </el-table-column>
        <el-table-column prop="Equipment" :label="$t('lang.Equipment type')" width="160">
          <template slot-scope="{row}">
            {{ $t('lang.Battery') }}
          </template>
        </el-table-column>
        <el-table-column prop="Online" :label="$t('lang.Online State')" width="150">
          <template slot-scope="{row}">
            {{ row.onlineFlagStr }}
          </template>
        </el-table-column>
        <el-table-column prop="version" :label="$t('lang.version')" width="100px">
          <template slot-scope="{row}">
            {{ versionMap[row.version] }}
          </template>
        </el-table-column>
        <el-table-column prop="Attribution" width="300"  :label="$t('lang.Attribution information')">
          <template slot-scope="{row}">
            <span v-html="row.belongTargetInfo ? row.belongTargetInfo : row.cleanBelongReason"></span>
          </template>
        </el-table-column>
        <el-table-column prop="Battery" :label="$t('lang.Battery Power')" width="150">
          <template slot-scope="{row}">
            {{ row.soc }}
          </template>
        </el-table-column>
        <el-table-column prop="Health" :label="$t('lang.Health level')" width="150">
          <template slot-scope="{row}">
            {{ row.soh }}
          </template>
        </el-table-column>
        <el-table-column width="200"  prop="Health" :label="$t('lang.Last update time')">
          <template slot-scope="{row}">
            {{ chengDateTime(row.lastUpdateTime) }}
          </template>
        </el-table-column>
        <el-table-column width="400" prop="Operating" :label="$t('lang.Operating')" fixed="right">
          <template slot-scope="{row}">
            <el-button type="primary" size="mini" @click="onDetailBtnClick(row)">{{ $t('lang.Look Details') }}</el-button>
            <el-button style="margin-top: 12px;" type="primary" size="mini" @click="onSnapshotBtnClick(row)">{{
              $t('lang.View equipment snapshot') }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- <div class="page-box">
        <div class="page-count">{{ $t('lang.The') }} {{ pageIndex }} {{ $t('lang.page') }}，{{ $t('lang.The current page') }} {{
          dataList.length }} {{ $t('lang.item') }}，{{ $t('lang.total') }} {{ total }} {{ $t('lang.item') }}</div>
        <div class="page-count">{{ $t('lang.Jump to') }}
          <el-input v-model="page" class="page-choose fixed-width-35" size="mini"></el-input>
          {{ $t('lang.page') }}
        </div>
        <div class="page-count text-btn" @click="onPageChooseBtnClick">{{ $t('lang.Jump to') }}</div>
        <div class="pre-btn" :class="preBtnDisabled ? 'disabled' : ''" @click="onPreBtnClick">{{ $t('lang.Previous page') }}
        </div>
        <div class="next-btn" :class="nextBtnDisabled ? 'disabled' : ''" @click="onNextBtnClick">{{ $t('lang.Next page') }}
        </div>
      </div> -->
      <div class="dfcc">
        <el-pagination
          :current-page="pageIndex"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10,20, 30, 40,50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <div class="main-body" v-if="view == 'add'">
      <battery-mgmt-add-view @addSuccess="addSuccessHandle" @cancel="cancelHandle"></battery-mgmt-add-view>
    </div>
    <div class="main-body" v-if="view == 'rebind'">
      <battery-mgmt-rebind-view :editData="editData" @editSuccess="editSuccessHandle"
        @cancel="cancelHandle"></battery-mgmt-rebind-view>
    </div>
    <div class="main-body" v-if="view == 'detail'">
      <battery-mgmt-detail-view :editData="editData" @cancel="cancelHandle"></battery-mgmt-detail-view>
    </div>
    <el-dialog :title="$t('lang.Import File')" :visible.sync="uploadDialogVisible" width="30%">
      <el-form label-position="right" label-width="80px">
        <el-form-item label="">
          <el-upload ref="fileUpload" action="" accept=".xls,.xlsx" :limit="1" :auto-upload="false"
            :on-change="handleFile" :file-list="uploadFileList">
            <el-button>{{ $t('lang.Add File') }}</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadDialogVisible = false">{{ $t('lang.Cancel') }}</el-button>
        <el-button type="primary" @click="onImportBtnConfirm">{{ $t('lang.Confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('lang.Edit battery ownership')" width="400px" :visible.sync="editBelongVisible" center>
      <el-form ref="form" label-width="100px">
        <el-form-item :label="$t('lang.Battery Number')">
          <el-input v-model="batteryNo" size="mini" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.User Phone')">
          <el-input v-model="phoneNo" size="mini"
            :placeholder="$t('lang.Please enter your mobile phone number')"></el-input>
        </el-form-item>
        <el-form-item v-if="voucherList.length > 0" :label="$t('lang.Selection Certificate')">
          <el-select v-model="voucherNo" size="mini">
            <el-option v-for="item in voucherList" :key="item.number" :label="item.name" :value="item.number">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" style="width: 150px;" @click="onEditBatteryBelongSubmit"
            :disabled="!batteryNo || !voucherNo || !phoneNo">{{ $t('lang.Confirm') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import BatteryMgmtAddView from "./batteryMgmtAddView";
import BatteryMgmtRebindView from "./batteryMgmtRebindView";
import BatteryMgmtDetailView from "./batteryMgmtDetailView";
import Utils from "../../utils/utils";
import { online_Flag_status } from '@/utils/constant'
export default {
  name: 'batteryMgmt',
  components: { BatteryMgmtDetailView, BatteryMgmtRebindView, BatteryMgmtAddView },
  data() {
    return {
      online_Flag_status,
      view: "list",
      searchCondition: '',
      belongType: '',
      belongTargetList: [
        {
          name: this.$t('lang.All'),
          id: '',
        },
        {
          name: this.$t('lang.user'),
          id: '1',
        },
        {
          name: this.$t('lang.Name of'),
          id: '2',
        },
      ],
      belongTargetTypeMap: {
        '0': this.$t('lang.Name of'),
        '1': this.$t('lang.user')
      },
      belongSubNo: '',
      belongTargetSeqList: [this.$t('lang.All'), '1号', '2号', '3号', '4号', '5号', '6号', '7号', '8号', '9号', '10号', '11号', '12号',],
      belongTargetSeq: '',
      targetNumber: '',
      version: '',
      versionList: [
        {
          name: this.$t('lang.All'),
          id: '',
        },
        {
          name: 'v1.0',
          id: 1,
        },
        {
          name: 'v2.0',
          id: 2,
        }],
      versionMap: {
        1: 'v1.0',
        2: 'v2.0'
      },
      manufacturer: '',
      manufacturerList: [{
        name: this.$t('lang.All'),
        id: '',
      },
      {
        name: '安靠',
        id: 0,
      },
      {
        name: '慧橙',
        id: 1,
      },
      {
        name: '创明',
        id: 2,
      },
      {
        name: '光宇',
        id: 3,
      }],
      manufacturerMap: {
        0: '安靠',
        1: '慧橙',
        2: '创明',
        3: '光宇'
      },
      batteryStander: {
        40: '40V',
        60: '60V/72V',
      },
      status: '',
      statusList: [{
        name: this.$t('lang.All'),
        id: '',
      },
      {
        name: '待出厂',
        id: 0,
      },
      {
        name: '待投放（已出厂）',
        id: 1,
      },
      {
        name: '已投放',
        id: 2,
      },
      {
        name: '待投放（返厂）',
        id: 3,
      },
      {
        name: '报废',
        id: 4,
      }],
      useStatusMap: {
        0: '待出厂',
        1: '待投放（已出厂）',
        2: '已投放',
        3: '待投放（返厂）',
        4: '报废'
      },
      unitNo: [],
      unitList: [],
      pageSize: 10,
      beginIndex: 1,
      pageIndex: 1,
      page: 1,
      total: '',
      totalPage: 0,
      preBtnDisabled: true,
      nextBtnDisabled: false,
      dataList: [],
      editData: {},
      file: null,
      uploadDialogVisible: false,
      editBelongVisible: false,
      uploadFileList: [],
      batteryNo: "",
      phoneNo: "",
      voucherList: [],
      voucherNo: "",
      domainType: ''
    }
  },
  mounted() {
    if (this.$route.query.searchCondition) {
      this.searchCondition = this.$route.query.searchCondition;
    }
    if (this.$route.query.belongTarget) {
      this.belongType = this.$route.query.belongTarget;
    }
    if (this.$route.query.targetNumber) {
      this.targetNumber = this.$route.query.targetNumber;
    }
    if (this.$route.query.belongTargetSeq) {
      this.belongTargetSeq = this.$route.query.belongTargetSeq;
    }
    if (this.$route.query.version) {
      this.version = parseInt(this.$route.query.version);
    }
    if (this.$route.query.status) {
      this.status = parseInt(this.$route.query.status);
    }
    if (this.$route.query.manufacturer) {
      this.manufacturer = parseInt(this.$route.query.manufacturer);
    }
    if (this.$route.query.beginIndex) {
      this.beginIndex = this.$route.query.beginIndex;
    }
    if (this.$route.query.primaryDeviceNo) {
      let data = { deviceNo: this.$route.query.primaryDeviceNo };
      this.onDetailBtnClick(data);
    }
    let domain = Utils.getDomain();
    if (domain == 'iot.lititi.com' || domain == 'hailixinnengyuan.com' || domain == 'leasehold-test.lititi.com' || domain == 'leasehold-dev.lititi.com') {
      this.domainType = '2';
    }
    this.queryDeviceList();
    this.getUnitMember();
  },
  watch: {
    phoneNo: function () {
      this.voucherNo = "";
      this.voucherList = [];
      if (!(/^1[3456789]\d{9}$/.test(this.phoneNo))) {
        return;
      }
      this.queryUserEffectiveVoucher();
    }
  },
  methods: {
    getUnitMember() {
      let self = this;
      let params = {
        authorityType: 204
      }
      this.$http.post('/managementPlatform/unit/queryManagedUnit', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.unitList = res.mdata.unitTree;
      }).catch(function (response) {
        console.log(response);
      });
    },
    onEditBelongClick: function (batteryInfo) {
      this.batteryNo = batteryInfo.deviceNo;
      this.phoneNo = "";
      this.voucherNo = ""
      this.voucherList = [];
      this.editBelongVisible = true;
    },
    onEditBatteryBelongSubmit: function (batteryInfo) {
      this.$confirm("确定将电池归属于此用户?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.changeBatteryBelongToUser();
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消"
        });
      });
    },
    chengDateTime : function (time) {
    if(!time){
        return '';
    }
    const date = new Date(+time);
    var year = date.getFullYear().toString().padStart(2,'0');
    var month = (date.getMonth() + 1).toString().padStart(2,'0');
    var day = date.getDate().toString().padStart(2,'0');
    var hour = date.getHours().toString().padStart(2,'0');
    var minute = date.getMinutes().toString().padStart(2,'0');
    var sec = date.getSeconds().toString().padStart(2,'0');
    return `${year}-${month}-${day} ${hour}:${minute}:${sec}`
},
    queryUserEffectiveVoucher: function () {
      let self = this;
      let params = {
        phoneNo: this.phoneNo,
        type: 4
      };
      this.$http.post('/managementPlatform/admin/queryUserEffectiveVoucher', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        self.voucherList = res.ldata;
      }).catch(function (response) {
        console.log(response);
      });
    },
    changeBatteryBelongToUser: function () {
      let self = this;
      let params = {
        phoneNo: this.phoneNo,
        batteryProperty: this.batteryNo,
        voucherNo: this.voucherNo
      };
      this.$http.post('/managementPlatform/admin/changeBatteryBelongToUser', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "操作失败!",
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: "操作成功!"
        });
        self.editBelongVisible = false;
      }).catch(function (response) {
        console.log(response);
      });
    },
    queryDeviceList: function () {
      let self = this;
      let params = {
        searchCondition: this.searchCondition,
        belongType: this.belongType,
        belongNumber: this.targetNumber,
        belongSubNo: this.belongSubNo,
        belongTargetSeq: this.belongTargetSeq ? this.belongTargetSeq : '',
        version: this.version,
        status: this.status,
        manufacturer: this.manufacturer,
        unitNo: this.unitNo[this.unitNo.length - 1],
        beginIndex: (this.beginIndex-1)*this.pageSize,
        pageSize: this.pageSize
      };
      this.$http.post('/managementPlatform/electricity/batteryInfo', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        self.dataList = res.ldata;
        self.resetPreAndNextBtn(self.dataList.length);
        self.dataList.length > self.pageSize && self.dataList.pop();
        self.page = Math.floor(self.beginIndex / self.pageSize) + 1;
        self.pageIndex = self.page;
        self.total = res.mdata.total;
        self.totalPage = Math.floor((parseInt(res.mdata.total) - 1) / self.pageSize) + 1;
      }).catch(function (response) {
        console.log(response);
      });
    },
    onPreBtnClick() {
      if (this.preBtnDisabled) {
        return;
      }
      this.beginIndex <= this.pageSize && (this.beginIndex = 1);
      this.beginIndex > this.pageSize && (this.beginIndex -= this.pageSize);
      this.queryDeviceList();
    },
    onNextBtnClick() {
      if (this.nextBtnDisabled) {
        return;
      }
      this.beginIndex += this.pageSize;
      this.queryDeviceList();
    },
    resetPreAndNextBtn(length) {
      this.beginIndex == 0 && (this.preBtnDisabled = true);
      this.beginIndex > 0 && (this.preBtnDisabled = false);
      length > this.pageSize && (this.nextBtnDisabled = false);
      length <= this.pageSize && (this.nextBtnDisabled = true);
    },
    targetNumberChange() {
      if (!this.targetNumber) {
        this.belongTargetSeq = '';
      }
    },
    onQueryBtnClick() {
      this.beginIndex = 1;
      this.queryDeviceList();
    },
    onPageChooseBtnClick() {
      let index = 0;
      if (this.page <= this.totalPage && this.page > 0) {
        index = this.page;
      } else {
        index = 1;
        this.page = 1;
      }
      this.beginIndex = (index - 1) * this.pageSize;
      this.queryDeviceList();
    },
    onAddBtnClick() {
      this.view = 'add';
    },
    confirmDownloadBtnClick() {
      let self = this;
      this.$confirm(this.$t('lang.Whether to confirm export'), "", {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.Cancel'),
        type: "warning"
      })
        .then(() => {
          self.onDownloadBtnClick();
        })
        .catch(action => {
        });
    },
    onDownloadBtnClick() {
      let self = this;
      let params = {
        searchCondition: this.searchCondition,
        belongType: this.belongType,
        belongNumber: this.targetNumber,
        belongSubNo: this.belongSubNo,
        belongTargetSeq: this.belongTargetSeq ? this.belongTargetSeq : '',
        version: this.version,
        status: this.status,
        manufacturer: this.manufacturer,
        unitNo: this.unitNo[this.unitNo.length - 1],
      };
      this.$http.post("/managementPlatform/batteryInfoExport", this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          })
          return;
        }
        self.$message({
          type: "success",
          message: this.$t('lang.Export successful'),
          center: true
        })
        setTimeout(function () {
          self.$router.push('/managePage/downloadTask')
        }, 1000)
      }).catch(function (response) {

      });
    },
    onMileageBtnClick() {
      this.$router.push('/managePage/batteryMileage?searchCondition=' + this.searchCondition + "&belongTarget=" + this.belongType + "&targetNumber=" + this.targetNumber
        + "&belongTargetSeq=" + this.belongTargetSeq + "&version=" + this.version + "&status=" + this.status + "&manufacturer=" + this.manufacturer + "&beginIndex=" + this.beginIndex)
    },

    onViewTrackBtnClick() {
      this.$router.push('/managePage/batteryTrack?searchCondition=' + this.searchCondition + "&belongTarget=" + this.belongType + "&targetNumber=" + this.targetNumber
        + "&belongTargetSeq=" + this.belongTargetSeq + "&version=" + this.version + "&status=" + this.status + "&manufacturer=" + this.manufacturer + "&beginIndex=" + this.beginIndex)
    },
    onEditBtnClick(data) {
      this.view = 'edit';
      this.$nextTick(() => {
        this.editData = data;
      });
    },
    onRebindBtnClick(data) {
      this.view = 'rebind';
      this.$nextTick(() => {
        this.editData = data;
      });
    },
    onQueryBelongRecordClick(data) {
      this.$router.push("/managePage/batteryBelongRecord?batteryParam=" + data.deviceNo)
    },
    onDetailBtnClick(data) {
      this.view = 'detail';
      this.$nextTick(() => {
        this.editData = data;
      });
    },
    onSnapshotBtnClick(data) {
      this.$router.push("/managePage/batterySnapShot?primaryDeviceNo=" + data.deviceNo + "&communicationBoardNo=" + data.communicationBoardNo + "&searchCondition=" + this.searchCondition + "&belongTarget=" + this.belongType + "&targetNumber=" + this.targetNumber
        + "&belongTargetSeq=" + this.belongTargetSeq + "&version=" + this.version + "&status=" + this.status + "&manufacturer=" + this.manufacturer + "&beginIndex=" + this.beginIndex)
    },
    addSuccessHandle() {
      this.view = 'list';
      this.beginIndex = 1;
      this.queryDeviceList();
    },
    editSuccessHandle() {
      this.view = 'list';
      this.queryDeviceList();
    },
    cancelHandle() {
      this.view = 'list';
      this.queryDeviceList();
    },
    handleFile(file, fileList) {
      this.file = file.raw;
      return false
    },
    onImportBtnClick() {
      this.file = null;
      this.uploadDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.fileUpload.clearFiles();
      });
    },
    onImportBtnConfirm() {
      let params = {
        uploadFile: this.file
      };
      let formData = new FormData();
      for (let key in params) {
        formData.append(key, params[key]);
      }
      this.$http.post('/managementPlatform/electricity/updateBatteryByFile', formData).then(response => {
        let res = response.data;
        if (!res || !res.result) {
          this.$message({
            type: "error",
            message: res.message || "操作失败!",
            center: true
          });
          return;
        }
        this.uploadDialogVisible = false;
        this.$message({
          type: "success",
          message: '上传成功',
          center: true
        });
      }).catch(err => {
        console.log(err);
      });
    },
    handleCurrentChange(page) {
      this.beginIndex = page ;
      this.queryDeviceList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.queryDeviceList();
    },
  },
}
</script>

<style lang="scss" scoped>
.list {
  width: 100% !important;
  line-height: 30px;
  margin: 20px 30px 10px;

  .name-label {
    float: left;
  }

  .value-label {
    display: inline-block;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }

  .fixed-width-100 {
    width: 100px;
  }

  .fixed-width-115 {
    width: 115px;
  }

  .fixed-width-125 {
    width: 125px;
  }

  .fixed-width-200 {
    width: 200px;
  }

  .fixed-width-300 {
    width: 300px;
  }
}

.table-custom {
  .text-btn {
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
    padding: 2px 8px;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-100 {
    width: 100px;
  }

  .fixed-width-100 {
    width: 100px;
  }

  .mt4 {
    margin-top: 4px;
  }
}

tr th {
  width: 12.5% !important;
}
  // 滚动条
  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; // 横向滚动条
    height: 10px; // 纵向滚动条 必写
  }
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/batteryMgmt.vue